import React from 'react';
import PropTypes from 'prop-types';
import {
  CalendarToday,
  CardGiftcard,
  CheckCircleOutline,
  EmojiEvents,
  Forum,
  MilitaryTech,
  PhotoCamera,
  ShowChart,
  StarOutline,
  WarningAmber
} from '@mui/icons-material';
import NotificationRowContent from 'components/notifications/NotificationRowContent';

// Claves que el backend manda en `data.icon`. Las que faltaban degradaban todas a la
// estrella y la bandeja se veía como una columna del mismo icono repetido.
const ICON_MAP = {
  trophy: EmojiEvents,
  star: StarOutline,
  calendar: CalendarToday,
  gift: CardGiftcard,
  check: CheckCircleOutline,
  'check-circle': CheckCircleOutline,
  award: MilitaryTech,
  'chart-line': ShowChart,
  forum: Forum,
  warning: WarningAmber,
  camera: PhotoCamera
};

// El `data.color` que manda el backend se IGNORA a propósito: la bandeja es monocroma y el
// único acento es el punto dorado de no leída.
function GenericNotification({ notification, icon = 'star' }) {
  // Algunas notificaciones (gamificación) pueden llegar sin `data`; sin este guard
  // `data.title` lanza y, con el boundary, deja la campana sin contenido.
  const data = notification.data || {};

  return (
    <NotificationRowContent
      notification={notification}
      icon={ICON_MAP[icon] || StarOutline}
      title={data.title || data.message || ''}
      body={data.title ? data.message : null}
    />
  );
}

GenericNotification.propTypes = {
  icon: PropTypes.string,
  notification: PropTypes.shape({
    created_at: PropTypes.string,
    data: PropTypes.shape({
      message: PropTypes.string,
      title: PropTypes.string
    }),
    id: PropTypes.string.isRequired,
    read: PropTypes.bool
  }).isRequired
};

export default GenericNotification;
